var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.000244141,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#2F65CC",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6702 22H12.0002C10.9002 22 10.0002 22.9 10.0002 24V29C10.0002 29.55 10.4502 30 11.0002 30H14.6702C15.2202 30 15.6702 29.55 15.6702 29V23C15.6702 22.45 15.2202 22 14.6702 22Z",
    fill: "#2F65CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3302 18H18.6602C17.5602 18 16.6602 18.9 16.6602 20V29C16.6602 29.55 17.1102 30 17.6602 30H22.3302C22.8802 30 23.3302 29.55 23.3302 29V20C23.3302 18.9 22.4402 18 21.3302 18Z",
    fill: "#2F65CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0003 25H25.3303C24.7803 25 24.3303 25.45 24.3303 26V29C24.3303 29.55 24.7803 30 25.3303 30H29.0003C29.5503 30 30.0003 29.55 30.0003 29V27C30.0003 25.9 29.1003 25 28.0003 25Z",
    fill: "#2F65CC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0102 12.8505C23.3202 12.5405 23.4402 12.1705 23.3402 11.8505C23.2402 11.5305 22.9302 11.3005 22.4902 11.2305L21.5302 11.0705C21.4902 11.0705 21.4002 11.0005 21.3802 10.9605L20.8502 9.90047C20.4502 9.09047 19.5402 9.09047 19.1402 9.90047L18.6102 10.9605C18.6002 11.0005 18.5102 11.0705 18.4702 11.0705L17.5102 11.2305C17.0702 11.3005 16.7702 11.5305 16.6602 11.8505C16.5602 12.1705 16.6802 12.5405 16.9902 12.8505L17.7302 13.6005C17.7702 13.6305 17.8002 13.7505 17.7902 13.7905L17.5802 14.7105C17.4202 15.4005 17.6802 15.7105 17.8502 15.8305C18.0202 15.9505 18.3902 16.1105 19.0002 15.7505L19.9002 15.2205C19.9402 15.1905 20.0702 15.1905 20.1102 15.2205L21.0002 15.7505C21.2802 15.9205 21.5102 15.9705 21.6902 15.9705C21.9002 15.9705 22.0502 15.8905 22.1402 15.8305C22.3102 15.7105 22.5702 15.4005 22.4102 14.7105L22.2002 13.7905C22.1902 13.7405 22.2202 13.6305 22.2602 13.6005L23.0102 12.8505Z",
    fill: "#2F65CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01);
export default __webpack_public_path__ + "static/media/01.339578977dbe1f110351b159c171b933.svg";
export { ForwardRef as ReactComponent };